export default "__VITE_ASSET__DNq9Ejc___"